













import { computed, defineComponent, getCurrentInstance } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import { $t } from "@/lib/i18nHelpers";
import { getAbsUrl, getLiveUrl, shareUrl } from "@/lib/urlHelpers";
import router from "@/router";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseInputFile from "@/components/BaseInputFile";
import PageTitle from "@/components/PageTitle";
import Share from "@/components/Share";

export default defineComponent({
  name: "GoingLiveConfirm",
  components: { BaseConfirm, BaseInputFile, PageTitle, BaseButton, Share },
  props: {
    show: { type: Boolean, required: true },
  },
  setup() {
    const vm = getCurrentInstance();
    const { authUserStrict } = useAuthUser();
    const liveUrl = getLiveUrl(authUserStrict.value);
    const shareLink = computed(() => {
      const urlPart = vm?.$router.resolve(liveUrl).href;
      return urlPart ? getAbsUrl(urlPart) : "";
    });
    const copyLiveLink = () => shareUrl(shareLink.value, $t("Link copied"));
    const goLive = () => {
      router.push(liveUrl);
    };

    return {
      shareLink,
      copyLiveLink,
      goLive,
    };
  },
});
